<template>
  <BaseButton primary :disabled="pending" @click="createGoogleAdsChannel">
    Add Google Ads Channel
  </BaseButton>
</template>

<script>
import { campaignChannelsClient } from '@/api/clients';

export default {
  props: {
    campaignId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      pending: false,
    };
  },
  methods: {
    setPending(value) {
      this.pending = value;
    },
    async createGoogleAdsChannel() {
      try {
        this.setPending(true);

        await campaignChannelsClient.store(this.campaignId, {
          channableType: 'ga_campaign',
        });

        this.$emit('saved');
      } catch (error) {
        //
      } finally {
        this.setPending(false);
      }
    },
  },
};
</script>
